/**
 * Cómo se lee un renglón de la bitácora. El flujo de eventos (D018) guarda
 * `accion` como clave del sistema («cuentas.contrasena_repuesta»); una
 * persona lee «repuso la contraseña». Lo que no esté aquí se muestra con su
 * clave: se ve feo y se nota, que es justo lo que debe pasar para que alguien
 * lo agregue.
 */

const FRASES: Record<string, string> = {
  // Los nombres son los que escribe la API (grep de `eventos.registrar`),
  // más los `<recurso>.crear` / `.editar` del generador (D023) y los que
  // dejan las puertas del CLI (db/041).
  "acceso.entrar": "entró",
  "acceso.salir": "salió",
  "acceso.fallido": "intentó entrar sin éxito",
  "cuentas.contrasena_repuesta": "repuso una contraseña",
  "cuentas.primer_admin": "arrancó la campaña con el primer admin",
  "territorio.arrancado": "cargó el territorio de un municipio",
  "usuarios.crear": "dio de alta una cuenta",
  "usuarios.editar": "editó una cuenta",
  "metas.crear": "creó una meta",
  "metas.editar": "ajustó una meta",
  "campanias.crear": "creó una campaña de contacto",
  "campanias.editar": "editó una campaña de contacto",
  "bandeja.tomar": "tomó una captura de la bandeja",
  "bandeja.aprobar": "aprobó una captura",
  "bandeja.rechazar": "rechazó una captura",
  "bandeja.ver_adjunto": "vio el documento de una captura",
  "cumplimiento.solicitud_levantada": "levantó una solicitud ARCO",
  "cumplimiento.cancelacion_ejercida": "ejerció una cancelación ARCO",
  "verificacion.consultada": "consultó una identidad",
  "verificacion.error": "no pudo consultar una identidad",
  "confianza.evaluar": "corrió la detección de confianza",
  "targeting.senal_declarada": "declaró una señal de targeting",
  "conector.revertir": "revirtió una importación",
};

export function fraseDeAccion(accion: string): string {
  const f = FRASES[accion];
  if (f) return f;
  // «usuarios.crear» sin frase → «usuarios: crear». Legible y reconocible.
  return accion.replace(".", ": ").replace(/_/g, " ");
}

/** Qué entidad y cuál, cuando viene. «cuentas.usuario 12» → «cuenta 12». */
export function fraseDeEntidad(entidad: string | null, id: string | null): string {
  if (!entidad) return "";
  const nombre = entidad.split(".").pop() ?? entidad;
  return id ? `${nombre} ${id}` : nombre;
}
